(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[260],{

/***/ "LQjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/tour-information/TourInformation.jsx
var TourInformation = __webpack_require__("HnVD");

// CONCATENATED MODULE: ./src/client/components/lines/tour-introduction-line/TourIntroductionLine.jsx
var __jsx = react_default.a.createElement;



var TourIntroductionLine_TourIntroductionLine = function TourIntroductionLine(_ref) {
  var highlightTitle = _ref.highlightTitle,
      resort = _ref.resort,
      roadmapTitle = _ref.roadmapTitle;
  var details = resort.details,
      strengths = resort.strengths;
  var infos = [];

  if (details && details.length) {
    infos.push({
      title: roadmapTitle,
      items: details
    });
  }

  if (strengths && strengths.length) {
    infos.push({
      title: highlightTitle,
      items: strengths
    });
  }

  if (!infos.length) {
    return null;
  }

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, __jsx(TourInformation["a" /* TourInformation */], {
    infos: infos
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-introduction/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (TourIntroductionLine_TourIntroductionLine);

/***/ })

}]);